import React, { useEffect, useRef, useState } from 'react'
import {
  default as palette,
  default as pallete
} from '../../../global/newPallete'

import { ChartColumnTarget } from '@carbon/icons-react'
import { DDSTypography } from 'den-design-system'
import StringConstants from '../../../constants/StringConstants'
import Tooltip from '../../../components/New/Tooltip/Tooltip'
import { observer } from 'mobx-react-lite'
import { replaceUrl } from '../../../utils/UrlUtils'
import routeConstants from '../../../constants/RouteConstants'
import { useNavigate } from 'react-router-dom'
import { useStoreContext } from '../../../store/StoreContext'

interface CircularProgressSectionProps {
  isSidebarExpanded: boolean
}

const ControlCenterSection: React.FC<CircularProgressSectionProps> = ({
  isSidebarExpanded
}) => {
  const store = useStoreContext()
  const navigate = useNavigate()
  const buttonRef = useRef<HTMLDivElement>(null)
  const [isControlCenterActive, setIsControlCenterActive] = useState(false)

  const [selectedOption, setselectedOption] = React.useState<boolean>(false)

  const gettingStartedHandler = {
    id: 20,
    title: 'Control Center',
    link: routeConstants.CONTROL_CENTER,
    leftIcon: <ChartColumnTarget />,
    topIcon: <ChartColumnTarget size={24} color={pallete.colors.primary2} />
  }

  const toolTipStyle: React.CSSProperties = {
    borderColor: pallete.colors.stroke2,
    backgroundColor: pallete.colors.surface4,
    minWidth: 'max-content',
    position: 'fixed',
    zIndex: 99999
  }

  useEffect(() => {
    const controlCenter = window.location.href.includes('control-center')
    setIsControlCenterActive(controlCenter)
  }, [window.location.href])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        if (!isControlCenterActive) {
          setselectedOption(false)
        }
      }
    }

    if (isControlCenterActive) {
      store.uiStore.setSidebarItem(gettingStartedHandler)
      setselectedOption(true)
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isControlCenterActive])

  const isActive =
    sessionStorage.getItem(StringConstants.ACTIVE_TAB) ===
    StringConstants.TAB_VALUES.CONTROL_CENTER

  const handleClick = () => {
    sessionStorage.setItem(
      StringConstants.ACTIVE_TAB,
      StringConstants.TAB_VALUES.CONTROL_CENTER
    )
    setselectedOption(true)

    navigate(
      replaceUrl(
        routeConstants.CONTROL_CENTER,
        store.scopeStore.getScope()['organization-id'] as string,
        store.scopeStore.getScope()['project-id'] as string,
        store.scopeStore.getScope()['environment-id'] as string
      )
    )
  }

  return (
    <div className={`w-full cursor-pointer `} onClick={handleClick}>
      {isSidebarExpanded ? (
        <div
          className={` relative cursor-pointer flex items-center h-[42px] px-[20px] gap-x-[12px] ${
            store.uiStore.getGlobalLoader() ||
            store.uiStore.getprojectEnvironmentLoader() ||
            (store.projectStore.getLoading() &&
              'cursor-not-allowed pointer-events-none')
          }`}
          style={{
            backgroundColor: isActive ? palette.colors.primary1 : 'transparent'
          }}
        >
          {isActive && (
            <div
              className='absolute left-0 top-0 h-full w-[8px] '
              style={{ backgroundColor: palette.colors.primary2 }}
            />
          )}

          <ChartColumnTarget
            size={24}
            color={
              isActive ? palette.colors.textDark1 : palette.colors.textDark6
            }
          />

          <DDSTypography.Paragraph
            variant='medium'
            size='para'
            color={
              isActive ? palette.colors.textDark1 : palette.colors.textDark6
            }
          >
            Control Center
          </DDSTypography.Paragraph>
        </div>
      ) : (
        <div
          style={{
            backgroundColor: isActive ? palette.colors.primary1 : 'transparent'
          }}
          className={` relative flex justify-center cursor-pointer items-center h-[42px] ${
            store.uiStore.getGlobalLoader() ||
            store.uiStore.getprojectEnvironmentLoader() ||
            (store.projectStore.getLoading() &&
              'cursor-not-allowed pointer-events-none')
          }`}
        >
          <Tooltip
            id={'controlCenterIconToolTip'}
            label={
              <div style={{ color: pallete.colors.fillButtonhover }}>
                Control Center
              </div>
            }
            className={`border override-tooltip-arrow max-w-[90%] break-all`}
            position='right'
            style={toolTipStyle}
          >
            <ChartColumnTarget
              size={24}
              color={
                isActive ? palette.colors.textDark1 : palette.colors.textDark6
              }
            />
          </Tooltip>

          {isActive && (
            <div
              className='absolute left-0 top-0 h-full w-[8px] '
              style={{ backgroundColor: palette.colors.primary2 }}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default observer(ControlCenterSection)
